import { getWsBasePath } from "../utils";
import { WechatAddOriginType, WechatApplySceneType } from "../types";

export const WECHAT_ACCOUNT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/WECHAT/ACCOUNT`;
export const WECHAT_CONTACT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/WECHAT/CONTACT`;
export const WECHAT_CHAT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/WECHAT/CHAT`;

export const wechatAddOrigins = {
  [WechatAddOriginType.BY_SCAN]: "对方通过扫一扫添加",
  [WechatAddOriginType.BY_BUSINESSCARD]: "对方通过名片分享添加",
  [WechatAddOriginType.BY_ROOM]: "对方通过群聊添加",
  [WechatAddOriginType.BY_SEARCH_ACCOUNT]: "对方通过搜索账号添加",
  [WechatAddOriginType.SEARCH_TEL]: "通过搜索手机号添加",
};

export const wechatApplyScenes = {
  [WechatApplySceneType.FRIEND_VERIFY_MESSAGE]: "朋友验证消息",
  [WechatApplySceneType.BY_SCAN]: "对方通过扫一扫添加",
  [WechatApplySceneType.BY_BUSINESSCARD]: "对方通过分享的名片添加",
  [WechatApplySceneType.BY_SEARCH_ACCOUNT]: "对方通过搜索账号添加",
};
